import { useFormik } from "formik";
import { useState } from 'react';
// import { GoogleLogin } from 'react-google-login';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as Yup from "yup";
import { ReactComponent as CloseButton } from "../../../assets/images/closeX.svg";
import { ReactComponent as EyeSvg } from "../../../assets/images/eye.svg";
import { ReactComponent as HideSvg } from "../../../assets/images/hide.svg";
import { ReactComponent as LoaderSpinner } from "../../../assets/images/loader.svg";
import { closeLoginModalFunc } from '../../../redux/Modal/modal.actions';
import { loginUser } from '../../../redux/User/user.actions';
import { FieldWrapper, Form, FormInput, FormTitle, InputLabel, SignInButton, Wrapper } from "./style";
const validationSchema = Yup.object().shape({
    email: Yup.string()
        .email("Please provide a valid email address")
        .required("Email is required"),
    password: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .required("Password cannot be empty"),
});

const LogInForm = ({ hideFunc }) => {

    const [hidePassword, setHidePassword] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const dispatch = useDispatch();

    const handlePasswordToggle = () => {
        setHidePassword((prev) => !prev);
    };
    const handleFormSubmit = async () => {
        const { email, password } = values;
        try {
            await setIsLoading(true)
            await dispatch(loginUser(email, password))
            await setIsLoading(false)
            history.push('/host-events');
        } catch (error) {
            console.log(error);
        }
    }
    const formik = useFormik({
        initialValues: {
            email: "",
            password: ""
        },
        validationSchema,
        onSubmit: handleFormSubmit,
    });


    const { values, errors, handleChange, handleSubmit, touched } = formik;


    // const googleSuccess = async (googleData) => {

    //     try {
    //         const { data } = await API.post('/api/v1/auth/google', { token: googleData.tokenId }, {
    //             headers: {
    //                 "Content-Type": "application/json"
    //             }
    //         });
    //         await dispatch({ type: userActionTypes.SET_CURRENT_USER, payload: data.user })
    //         await dispatch(closeLoginModalFunc())

    //     } catch (error) {
    //         if (error.response) {
    //             cogoToast.error(`${error.response.data.message}`)
    //         }
    //     }
    // }
    // const googleError = (err) => { console.log(err) }

    return (
        <Wrapper>
            <Form autocomplete="off" onSubmit={handleSubmit}>
                <FormTitle>Sign in</FormTitle>
                <FieldWrapper>
                    <div className="log_in_forn_label_wrapper">
                        <InputLabel htmlFor="#email">Email</InputLabel>

                    </div>
                    <FormInput
                        onChange={handleChange("email")}
                        autoComplete={"off"}
                        autoCorrect={"off"}
                        value={values.email}
                        name="email"
                        id="email"
                        placeholder={"livefreely@nofixedaddresses.com"}
                    />
                    {errors.email && touched.email && (
                        <small className="error">{errors.email}</small>
                    )}
                </FieldWrapper>
                <FieldWrapper>
                    <InputLabel htmlFor="#password">Password</InputLabel>
                    <div className="input_wrapper">
                        <FormInput
                            autoComplete={"off"}
                            onChange={handleChange("password")}
                            value={values.password}
                            name="password"
                            id="password"
                            type={hidePassword ? "password" : "text"}
                            placeholder={"Password"}
                        />
                        {hidePassword ? (
                            <EyeSvg onClick={handlePasswordToggle} />
                        ) : (
                            <HideSvg onClick={handlePasswordToggle} />
                        )}
                    </div>

                    {errors.password && touched.password && (
                        <small className="error">{errors.password}</small>
                    )}
                </FieldWrapper>
                <SignInButton type="submit">{isLoading ? <LoaderSpinner /> : "Sign in"}</SignInButton>
            </Form>
            <CloseButton onClick={() => dispatch(closeLoginModalFunc())} className="close-btn" />

            {/* <Divider>or</Divider> */}
            {/* <a href="http://localhost:4000/api/v1/auth/google">
            
            </a> */}
            {/*   <GoogleLogin
                clientId={process.env.REACT_APP_GOOGLR_CLIENT_ID}
                render={(renderProps) => (
                    <SignInWitHGoogleButton
                        onClick={renderProps.onClick}
                        disabled={renderProps.disabled}
                    />

                )}
                onSuccess={googleSuccess}
                onFailure={googleError}
                cookiePolicy="single_host_origin"
            /> */}
        </Wrapper>
    )
}

export default LogInForm
